import Link from 'next/link';

import SitemapHTML from '~/components/SitemapHTML';

import { notifyBugSnag } from '~/utils/ErrorChecking';
import Head from '~/components/Meta/Head';
import Breadcrumb from '~/components/Breadcrumb';
import ContentWrapper from '~/components/ContentWrapper';
import { states } from '~/utils/Provinces';
import styles from './agents-directory/index.module.scss';

const Index = (props) => {

  const breadcrumb = {
    crumbs: ['RealEstateAgents.com', 'State Directory'],
    asPath: ['/', '/state-directory'],
    pathname: ['/', '/state-directory'],
  };

  const renderLocations = () => {
      return states.map((state) => (
        <span className={styles.directory__link}>
          <Link
            prefetch={false}
            href="/[state_slug]"
            as={`/${state.short.toLowerCase()}`}
          >
            {state.name}
        </Link>
      </span>
    ));
  };

  return (
    <div className={styles.directory}>
      <Head
        url={`${process.env.CLIENT_ORIGIN}/states-directory`}
        title="States Directory | RealEstateAgents.com"
        description="A directory of the of US states"
      />
      <ContentWrapper>
        <Breadcrumb
          passedAsPath={breadcrumb && breadcrumb.asPath}
          passedPathname={breadcrumb && breadcrumb.pathname}
          passedCrumbs={breadcrumb && breadcrumb.crumbs}
          breadcrumbReady
          noCheck
        />
        <SitemapHTML
          breadcrumb={breadcrumb}
          title="Agents in the United States"
          description="Find the perfect real estate agent in any state."
          renderItems={renderLocations}
        />
      </ContentWrapper>
    </div>
  );
};

export async function getStaticProps(ctx) {
  try {
    const pageData = {};
    return {
      props: { pageData },
      revalidate: 60 * 5,
    };
  } catch (err) {
    console.log(err);
    const bugSnagMetadata = [
      {
        label: 'route',
        fields: {
          asPath: ctx.asPath,
          pathname: ctx.pathname,
          server_context: ctx,
          server: !!ctx.req,
        },
      },
    ];
    notifyBugSnag({ error: err, metadata: bugSnagMetadata });
    return { props: { pageData: {}, error: { code: 500 } }, revalidate: 1 };
  }
}

export default Index;
